export const EditViewWebLinks = {
  "title": "Select Page Links to Download",
  "stop": "Stop",
  "Download": "Download",
  "Cancel": "Cancel",
  "Properties": "Properties",
  "SelectAll": "Select All",
  "RemoveAll": "Clear All"
}